import {
  ADMIN_HEADER_HEIGHT,
  MAIN_SITE_HEADER_HEIGHT,
  STICKY_HEADER_HEIGHT,
  SUBSCRIPTION_TOP_BANNER_HEIGHT,
  TABS_HEIGHT,
} from "./constants";

const SCROLL_VARIANT_SHOW_PAD = 8;
const SCROLL_VARIANT_HIDE_PAD = 48;

export const measureRoundedHeight = (element: HTMLElement) => {
  return Math.round(element.getBoundingClientRect().height);
};

export const getNavOffset = (
  siteHeaderHeight: number,
  shouldRenderSubscriptionTopBanner: boolean | null,
  isMobile: boolean | null
) => {
  const base = siteHeaderHeight || MAIN_SITE_HEADER_HEIGHT;
  const subscriptionBanner =
    shouldRenderSubscriptionTopBanner && isMobile
      ? SUBSCRIPTION_TOP_BANNER_HEIGHT
      : 0;
  return base + subscriptionBanner;
};

export const getVisibleCompactHeight = (
  isMobile: boolean | null,
  isScrollVariant: boolean,
  compactHeaderHeight: number
) => {
  if (isMobile || !isScrollVariant) return 0;
  return compactHeaderHeight;
};

/** Sticky stack used when clicking nav / in-page anchors. */
export const getClickScrollOffset = (
  navOffset: number,
  isMobile: boolean | null,
  isAdmin: boolean,
  compactHeaderHeight: number
) => {
  const stickyPortion = isMobile
    ? isAdmin
      ? ADMIN_HEADER_HEIGHT
      : 0
    : compactHeaderHeight || STICKY_HEADER_HEIGHT;

  return navOffset + stickyPortion + TABS_HEIGHT;
};

export const getSpyActivateOffset = (
  navOffset: number,
  visibleCompactHeight: number
) => {
  return navOffset + visibleCompactHeight + TABS_HEIGHT + STICKY_HEADER_HEIGHT;
};

export const getScrollVariantLines = (navOffset: number) => {
  return {
    showLine: navOffset + SCROLL_VARIANT_SHOW_PAD,
    hideLine: navOffset + SCROLL_VARIANT_HIDE_PAD,
  };
};

/** Observe height; if the node is missing, wait until it appears in the DOM. */
export const observeElementHeight = (
  getElement: () => HTMLElement | null,
  onHeight: (height: number) => void
) => {
  let resizeObserver: ResizeObserver | null = null;
  let mutationObserver: MutationObserver | null = null;
  let observed: HTMLElement | null = null;

  const publish = (element: HTMLElement) => {
    onHeight(measureRoundedHeight(element));
  };

  const attach = (element: HTMLElement) => {
    if (observed === element) return;

    resizeObserver?.disconnect();
    observed = element;
    publish(element);

    resizeObserver = new ResizeObserver(() => publish(element));
    resizeObserver.observe(element);
  };

  const tryAttach = () => {
    const element = getElement();
    if (element) {
      attach(element);
      mutationObserver?.disconnect();
      mutationObserver = null;
    }
  };

  tryAttach();

  if (!observed) {
    mutationObserver = new MutationObserver(tryAttach);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  return () => {
    resizeObserver?.disconnect();
    mutationObserver?.disconnect();
  };
};
